import axios from 'axios';
import React, { useEffect, useRef, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { checkDoPaymentUrl } from '../../../reducer/requestEndpoints';
import { Spin, Button, Result } from 'antd';

const DoPaymentCheck = () => {
	const [searchParams] = useSearchParams();

	const [text, setText] = useState('Preparing your session...');
	const [redirectUrl, setRedirectUrl] = useState(null);
	const [showButton, setShowButton] = useState(false);
	const [hasError, setHasError] = useState(false);

	const retryCountRef = useRef(0);

	const operatorCode = searchParams.get('operatorCode');
	const machineNo = searchParams.get('machineNo');
	const outletCode = searchParams.get('outletCode');

	// Build the redirect URL. `includeOperatorCode` controls whether the resolved
	// operatorCode param is sent, matching old behavior where the failure path
	// only ever sent opId, not operatorCode.
	const buildRedirectUrl = (operator, includeOperatorCode = true) => {
		let baseUrl = '';

		const hostname = window.location.hostname;

		if (hostname.includes('cuciexpress')) {
			baseUrl = 'https://loyalty.cuciexpress.asia/welcome';
		} else if (hostname.includes('mywashstudio')) {
			baseUrl = 'https://loyalty.mywashstudio.com/welcome';
		} else if (hostname.includes('bubblespulse')) {
			baseUrl = 'https://loyalty.bubblespulse.com.my/welcome';
		} else if (hostname.includes('octopus')) {
			baseUrl = 'https://app.octopus-laundry.com/welcome';
		} else {
			return null;
		}

		const paramObj = {
			machineNo: machineNo || '',
			outletCode: outletCode || '',
			opId: operatorCode || '',
		};

		if (includeOperatorCode) {
			paramObj.operatorCode = operator || '';
		}

		const params = new URLSearchParams(paramObj);

		return `${baseUrl}?${params.toString()}`;
	};

	const redirect = (urlOverride) => {
		const url = urlOverride || redirectUrl;
		if (!url) return;

		console.log('Redirecting to:', url);

		// Use replace (not href) to avoid leaving a history entry that could
		// re-trigger this page on iOS Safari back-navigation.
		window.location.replace(url);
	};

	const LEGACY_OPID_MAP = {
		"c04f7f2c102c9e556e60b4ace741112eede8b108638ab823": "5f047d87fefcf6715c9bd526"
	};

	const prepareRedirect = async () => {
		try {
			setText('Preparing your session...');
			let resolvedOpId = LEGACY_OPID_MAP[operatorCode];

			if (!resolvedOpId) {
				const response = await axios.get(
					`${checkDoPaymentUrl}?operatorCode=${operatorCode}`
				);
				resolvedOpId = response?.data?.data;
			}

			// const finalUrl = buildRedirectUrl(response?.data?.data || operatorCode, true);
			const finalUrl = buildRedirectUrl(resolvedOpId || operatorCode, true);

			if (!finalUrl) {
				setHasError(true);
				setText('Invalid QR code. Please scan the correct QR code.');
				return;
			}

			console.log('Final redirect URL:', finalUrl);

			setRedirectUrl(finalUrl);
			setText('Redirecting you now...');

			// auto redirect
			setTimeout(() => {
				redirect(finalUrl);
			}, 300);

			// fallback after 5 seconds in case auto-redirect silently fails (iOS Safari)
			setTimeout(() => {
				setShowButton(true);
				setText('Redirect is taking longer than expected.');
			}, 5000);

		} catch (error) {
			console.log('Redirect preparation failed:', error);

			// retry once (using a ref so this actually increments across calls)
			if (retryCountRef.current < 1) {
				retryCountRef.current += 1;
				setText('Retrying connection...');

				setTimeout(() => {
					prepareRedirect();
				}, 1500);

				return;
			}

			// fallback URL without API response — omit operatorCode to match old behavior
			const finalUrl = buildRedirectUrl(operatorCode, false);

			if (finalUrl) {
				setRedirectUrl(finalUrl);
				setHasError(true);
				setText('Connection failed, please continue manually.');
				setShowButton(true);
			} else {
				setHasError(true);
				setText('Server Error, please scan the correct QR code.');
			}
		}
	};

	useEffect(() => {
		prepareRedirect();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<div
			style={{
				minHeight: '100vh',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
				padding: '20px',
				background: '#fafafa'
			}}
		>
			<Result
				status={hasError ? 'warning' : 'info'}
				title={hasError ? 'Action needed' : 'Connecting...'}
				subTitle={text}
				icon={hasError ? undefined : <Spin size="large" />}
				extra={
					showButton && redirectUrl ? (
						<Button
							type="primary"
							size="large"
							onClick={() => redirect()}
						>
							Continue
						</Button>
					) : null
				}
			/>
		</div>
	);
};

export default DoPaymentCheck;